import {
  getInfomationFlowData,
  getInfomationFlowItemData,
  giveALikeByIFItemId,
  giveCollectByIFItemId,
  readedInformation,
  getCollectFlowData
} from '@/api/homeInfomationFlow'
import { getCommentCount } from '../../plugin/changyan'
const state = {
  informationFlow: {
    list: [],
    others: [],
    nomore: false,
    page: 0
  },
  videoInformationFlow: {
    list: [],
    others: [],
    nomore: false,
    page: 0
  },
  collectFlowData: {
    list: [],
    others: [],
    nomore: false,
    page: 0
  }
}
const mutations = {
  UPDATE_IF_DATA(state, list) {
    state.informationFlow.list = state.informationFlow.list.concat(list)
    state.informationFlow = Object.assign({}, state.informationFlow)
  },
  UPDATE_VIDEO_DATA(state, payload) {
    state.videoInformationFlow.list = (state.videoInformationFlow.list || []).concat(payload.list)
    state.videoInformationFlow = Object.assign({}, state.videoInformationFlow)
  },
  UPDATA_IF_OTHERS(state, item) {
    state.informationFlow.others.push(item)
  },
  // UPDATE_COLLECT_DATA(state, list) {
  //   state.collectFlowData.list = state.collectFlowData.list.concat(list)
  //   state.collectFlowData = Object.assign({}, state.collectFlowData)
  // },
  // 喜欢|收藏 后更新所有的数据
  UPDATE_ITEM_STATUS(state, item) {
    const updateRange = ['informationFlow', 'videoInformationFlow']
    const updateField = ['list', 'others']
    updateRange.forEach((field1) => {
      updateField.forEach((field2) => {
        const findIndex = state[field1][field2].findIndex((i) => i.id === item.id)
        if (findIndex > -1) {
          state[field1][field2].splice(findIndex, 1, {
            ...state[field1][field2][findIndex],
            ...item
          })
        }
      })
    })
  },
  CLEAN(state) {
    state.informationFlow.list = []
    state.informationFlow.page = 0
    state.informationFlow.nomore = false
  },
  CLEAN_VIDEOLIST(state) {
    state.videoInformationFlow = {
      list: [],
      others: [],
      nomore: false,
      page: 0
    }
  }
}
const actions = {
  // 获取信息流数据
  async getInformationFlowData({ commit, state, rootState }, payload = {}) {
    const search = payload.search || {}
    if (state.informationFlow.nomore) return false
    const wbGrade = rootState.user.userPref.wbGrade.slice(-2)
    const grade = `${wbGrade[0]}_${wbGrade[1]}`
    const { list, last } = await getInfomationFlowData({
      openid: rootState.user.openid,
      page: state.informationFlow.page++,
      size: 5,
      grade,
      search
    })
    state.informationFlow.nomore = last
    // 重载畅言评论sdk
    getCommentCount()
    commit('UPDATE_IF_DATA', list)
    return true
  },
  // // 获取收藏信息流数据
  // async getCollectFlowData({ commit, state, rootState }, payload = {}) {
  //   if (state.collectFlowData.nomore) return false
  //   const { list, last } = await getCollectFlowData({
  //     openid: rootState.user.openid,
  //     page: state.collectFlowData.page++,
  //     size: 5,
  //     type: 'collects'
  //   })
  //   state.collectFlowData.nomore = last
  //   // 重载畅言评论sdk
  //   getCommentCount()
  //   commit('UPDATE_COLLECT_DATA', list)
  //   return true
  // },
  // 根据信息流的id获取一条信息
  async getInformationFlowItemData({ commit, rootState }, id) {
    const informationFlowItem = state.informationFlow.list.find((item) => item.id === id)
    if (!informationFlowItem) {
      const item = await getInfomationFlowItemData({
        openid: rootState.user.openid,
        id
      })
      if (!item) throw new Error('获取数据出错')
      commit('UPDATA_IF_OTHERS', item)
      return item
    }
    return informationFlowItem
  },
  // 获取视频列表相关
  async getInformationFlowDataByVideoId({ commit, state, rootState }, payload = {}) {
    // 负载
    const search = payload.search || {}
    const id = payload.id
    // 分页结束
    if (state.videoInformationFlow.nomore) return false
    // 获取video列表
    const wbGrade = rootState.user.userPref.wbGrade.slice(-2)
    const grade = `${wbGrade[0]}_${wbGrade[1]}`
    const { list, last } = await getInfomationFlowData({
      openid: rootState.user.openid,
      page: state.videoInformationFlow.page++,
      size: 5,
      grade,
      search
    })
    // 获取 id 对应的数据,并放在首位
    const hasGetId =
      state.videoInformationFlow.list[0] && state.videoInformationFlow.list[0].id === id
    if (!hasGetId) {
      const item = await getInfomationFlowItemData({
        openid: rootState.user.openid,
        id
      })
      list.unshift(item)
    }
    // 设置分页状态
    state.videoInformationFlow.nomore = last
    // 重载畅言评论sdk
    getCommentCount()
    commit('UPDATE_VIDEO_DATA', { list, id })
    return true
  },
  // 切换喜欢状态
  async toggleInformastionGood({ commit, dispatch, state, rootState }, { id, other, item }) {
    const informationFlowItem = item
    return giveALikeByIFItemId({
      openid: rootState.user.openid,
      id
    }).then(({ data }) => {
      const good = informationFlowItem.good
      if (data.indexOf(id) > -1) {
        // 点赞
        good.number++
        good.clicked = true
        dispatch('collectData', { flowid: id, action: 1 }) // 数据收集
      } else {
        // 取消点赞
        good.clicked = false
        good.number--
        dispatch('collectData', { flowid: id, action: 2 }) // 数据收集
      }

      commit('UPDATE_ITEM_STATUS', informationFlowItem)
      return true
    })
  },
  // 切换收藏状态
  async toggleInformastionCollect({ commit, dispatch, state, rootState }, { id, other, item }) {
    const informationFlowItem = item
    return giveCollectByIFItemId({
      openid: rootState.user.openid,
      id
    }).then(({ data }) => {
      const collect = informationFlowItem.collect
      if (data.indexOf(id) > -1) {
        // 点赞
        collect.number++
        collect.clicked = true
        dispatch('collectData', { flowid: id, action: 1 }) // 数据收集
      } else {
        // 取消点赞
        collect.clicked = false
        collect.number--
        dispatch('collectData', { flowid: id, action: 2 }) // 数据收集
      }
      commit('UPDATE_ITEM_STATUS', informationFlowItem)
      return true
    })
  },
  /**
   *
   * @param {*}
   * @param {*} { id: 信息流id, other: 不再列表里, onlyCollectData: 只触发用户行为收集, 直播链接等带三 }
   */
  async readedInformation({ commit, dispatch, state, rootState }, { id, other, onlyCollectData }) {
    dispatch('collectData', { flowid: id, action: 3 }) // 数据收集
    if (onlyCollectData) return
    const informationFlowItem = !other
      ? state.informationFlow.list.find((item) => item.id === id)
      : state.informationFlow.others.find((item) => item.id === id)
    if (!informationFlowItem) return false
    return readedInformation({
      id,
      openid: rootState.user.openid
    }).then(({ data, status }) => {
      if (status === 200) {
        informationFlowItem.pv = data
      }
    })
  },
  /**
   *
   * @param {*}
   * @param {*} {  action: 1、点赞 2、取消点赞 3、阅读}
   */
  collectData({ rootGetters }, { flowid, action }) {
    const { appid, openid, vip } = rootGetters
    try {
      // eslint-disable-next-line no-undef
      Statistic.informationCollect(
        // getformData(
        {
          appid,
          openid,
          flowid,
          vip,
          action
        }
        // )
      )
    } catch (e) {

    }
  },
  /**
   * 清空列表数据后，拉去新的数据
   */
  async cleanThenGetNewData({ commit, dispatch }) {
    commit('CLEAN')
    dispatch('getInformationFlowData')
  }
}
const getters = {
  informationFlow(state) {
    return state.informationFlow
  },
  // collectFlowData(state) {
  //   return state.collectFlowData
  // },
  // eslint-disable-next-line space-before-function-paren
  informationFlowItemById: (state) => (id) => {
    const item = state.informationFlow.list.find((item) => item.id === id)
    const other = state.informationFlow.others.find((item) => item.id === id)
    return item || other
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
